import { useCallback, useContext } from "react";
import { ImperativeDialogContext } from "@repo/ui";

type ChangeWarningConfig = {
  changeType: "customer" | "workflow";
  newValue: number | null;
  onConfirm: (changeType: "customer" | "workflow", newValue: number | null) => void;
};

export const useChangeWarning = () => {
  const dialogContext = useContext(ImperativeDialogContext);
  const { showDialog, closeDialog } = dialogContext ?? {};

  const showChangeWarning = useCallback(
    ({ changeType, newValue, onConfirm }: ChangeWarningConfig) => {
      showDialog?.({
        title: "Warning",
        content: (
          <div className="space-y-3">
            <p className="text-gxe-primary text-center font-semibold">Progress Will Be Lost!</p>
            <p className="text-center">
              You have selected statuses that will be cleared if you change the{" "}
              {changeType === "customer" ? "customer" : "workflow"}.
            </p>
            <p className="text-right font-semibold">Do you want to continue?</p>
          </div>
        ),
        confirmText: "Continue",
        cancelText: "Cancel",
        cancelVariant: "secondary",
        confirmVariant: "primary",
        onConfirm: () => {
          onConfirm(changeType, newValue);
          closeDialog?.();
        },
        onCancel: () => {
          closeDialog?.();
        },
      });
    },
    [showDialog, closeDialog]
  );

  return { showChangeWarning };
};
